import { ProviderRegistration, ProviderRegistrationSearchRequest, ProviderRegistryApi } from "@asd/customer-portal-api";
import { AxiosResponse } from "axios";

import AxiosConfigurations, { AxiosConfiguration } from "./AxiosConfiguration";

import { axiosInstance } from ".";

export class ProviderRegistryService {
  static instance: ProviderRegistryService;
  private providerRegistryApi;
  private axiosConfiguration: AxiosConfiguration | undefined;

  constructor() {
    if (ProviderRegistryService.instance) {
      return ProviderRegistryService.instance;
    }

    this.providerRegistryApi = new ProviderRegistryApi(undefined, undefined, axiosInstance);
    const config = AxiosConfigurations.createAxiosConfiguration("ProviderRegistryService", this.providerRegistryApi);
    if (!config) {
      throw new Error("Failed to create AxiosConfiguration for ProviderRegistryService");
    }
    this.axiosConfiguration = config;

    ProviderRegistryService.instance = this;
  }

  public getPendingRequestCount() {
    return this.axiosConfiguration?.getPendingRequestCount();
  }

  public async getProviderRegistration(providerRegistrationId: string, options: object = {}) {
    if (!this.providerRegistryApi) {
      throw new Error("providerRegistryApi is not initialized");
    }

    try {
      const response: AxiosResponse = await this.providerRegistryApi.getProviderRegistration(providerRegistrationId, options);
      return response;
    } catch {
      // do nothing
    }
  }

  public async updateProviderRegistration(
    providerRegistrationId: string,
    providerRegistration: ProviderRegistration,
    options: object = {},
  ) {
    if (!this.providerRegistryApi) {
      throw new Error("providerRegistryApi is not initialized");
    }

    try {
      const response: AxiosResponse = await this.providerRegistryApi.updateProviderRegistration(
        providerRegistrationId,
        providerRegistration,
        options,
      );
      return response;
    } catch {
      // do nothing
    }
  }

  public async searchProviderRegistrations(providerRegistrationId: ProviderRegistrationSearchRequest, options: object = {}) {
    if (!this.providerRegistryApi) {
      throw new Error("providerRegistryApi is not initialized");
    }

    try {
      const response: AxiosResponse = await this.providerRegistryApi.searchProviderRegistrations(providerRegistrationId, options);
      return response;
    } catch {
      // do nothing
    }
  }

  public async contactProvider(providerRegistrationId: string, options: object = {}) {
    if (!this.providerRegistryApi) {
      throw new Error("providerRegistryApi is not initialized");
    }

    try {
      const response: AxiosResponse = await this.providerRegistryApi.contactProvider(providerRegistrationId, options);
      return response;
    } catch {
      // do nothing
    }
  }
}

export default new ProviderRegistryService();
